import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class LogUsuarioService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'log-usuario');
  }

  // Listar com filtros
  listar(filtros: any): Observable<any> {
    let params = new HttpParams();
    
    if (filtros.usuario_id) {
      params = params.set('usuario_id', filtros.usuario_id);
    }
    if (filtros.data_inicial) {
      params = params.set('data_inicial', filtros.data_inicial);
    }
    if (filtros.data_final) {
      params = params.set('data_final', filtros.data_final);
    }
    if (filtros.tabela_alterada) {
      params = params.set('tabela_alterada', filtros.tabela_alterada);
    }
    if (filtros.per_page) {
      params = params.set('per_page', filtros.per_page);
    }
    if (filtros.page) {
      params = params.set('page', filtros.page);
    }

    return this.http.get(`${this.url_base}/${this.prefixo}`, { params });
  }

}

